export default __webpack_public_path__ + "static/media/logo_df_vertical.06154dee.png";